// extracted by mini-css-extract-plugin
export default {"wrapper":"Qxnfo78JeMPhnLUWI2cK","logo":"qqahrvM908BZI7AbvzGD","title":"_9LpHPyJSuqT_jZyowt7N","text":"Bi_qhgc3I1IAQXi94BGh","button":"MQfDEskV56YKAvPsEEuY"};